import store from "@/store";

import { getMaxRecordLb } from "@/api/system";
import { checkDocumentExist } from "@/api/documentexist";
import { _updateData } from "@/api/esdata";
import { getFormOptions } from "@/api/formoptions";
import { assignMaxItemsCount } from "@/libs/assignFormOptions";

const isAdmin = store.state.userData.privilege == "admin";

export const settingZoneExplain = (parentVue) => {
    return {
        description:
            "<p>A <strong>ServiceGroup</strong> is a combination of <strong>SLBs</strong>, your site will map to a servicegroup before the DNS can be resolved. You can create multiple servicegroup base on your own strategy, such as <strong>GEO distribution</strong>, <strong>risk manage</strong> or even <strong>sites popularaty</strong>, it's all up to you.</p>",
    };
};

export const groupName = (parentVue) => {
    return {
        watchField: function (value, item) {},
    };
};

export const serviceGroupName = (parentVue) => {
    return {
        description: "<p>The name of your service group, this value must be unique.</p>",
        formTypes: ["createForm"],
        formRender: "FormInput",
        validate: [
            {
                required: true,
                message: "服務群組名稱 不能為空",
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\-\_]*$/.test(value))
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _`));
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    checkDocumentExist({
                        topic: "serviceGroupNameId",
                        fieldVal: value,
                        groupName: vm.formData.groupName,
                    }).then((result) => {
                        if (!result.data.success) {
                            return callback(new Error("此服務群組名無法使用"));
                        }
                        callback();
                    });
                },
                trigger: "blur",
            },
        ],
        render: (h, params) => h("p", {}, params.row.serviceGroupName),
    };
};
export const recordType = (parentVue) => {
    return {
        watchField: function (value, item) {
            var vm = parentVue.$refs.rcmTable;
            // assignSlbName({ groupNames: item.groupName, recordType: value });
            // assignProtectSlbName({ groupNames: item.groupName, recordType: value });
            // vm.formData.slbs = [];

            getMaxRecordLb({ recordType: value }).then((res) => {
                let storeEventName = value == "A" ? "SET_MAX_A_RECORDS_LB" : "SET_MAX_CNAME_RECORDS_LB";
                vm.$store.commit(storeEventName, res.data.data);
                assignMaxItemsCount(vm, "slbs", res.data.data);
                if (isAdmin) {
                    assignMaxItemsCount(vm, "protectSlbs", res.data.data);
                }
            });
        },
        isRunWatchFieldOnMount: true,
        validate: [
            {
                required: true,
                message: "Missing Record Type",
                trigger: "blur",
            },
        ],
    };
};

export const isEnabled = (parentVue) => {
    return {
        description:
            "<p>Toggle the status of servicegroup, when <strong>disabled</strong>, the DNS won't be resolved.</p>",
        render: (h, params) => {
            var status = params.row.isenabled;
            var vm = parentVue.$refs.rcmTable;
            const content = status
                ? vm.$i18n.t("servicegroup.disableIsEnabledStatusContent")
                : vm.$i18n.t("servicegroup.enableIsEnabledStatusContent");
            return h("i-switch", {
                props: {
                    value: status,
                    beforeChange() {
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("servicegroup.changeIsEnabledStatusText"),
                                content,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    },
                    disabled: vm.isEditBtnDisabled,
                },
                on: {
                    "on-change": (value) => {
                        params.row.isenabled = value;
                        delete params.row._index;
                        delete params.row._rowKey;
                        delete params.row._checked;
                        _updateData("rcm-servicegroup", "index", params.row)
                            .then((result) => {
                                vm.$Notice.success({
                                    title: vm.$i18n.t("global.success"),
                                    desc: `${result.data.message}`,
                                });
                            })
                            .catch(function (error) {
                                vm.$Notice.warning({
                                    title: vm.$i18n.t("global.error"),
                                    desc: `${error}`,
                                });
                                vm.getTableData();
                            });
                    },
                },
            });
        },
    };
};
export const slbs = (parentVue) => {
    return {
        description: "<p>The SLBs to put into the servicegroup.</p>",
        formTypes: ["createForm", "editForm"],
        maxItemsCount: 0,
        validate: [
            // {
            //     required: true,
            //     type: "array",
            //     message: "Missing slbs",
            //     trigger: "submit"
            // },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!vm.formData.slbs.length)
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("rcmtable.changeStatusText"),
                                content: "You are about to leave SLB empty, proceed carefully.",
                                width: 40,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    callback();
                },
                trigger: "submit",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (vm.formData.recordType == "A" && value.length > vm.$store.state.maxRecordLb.a)
                        return callback(new Error("Limit Exceeded"));
                    if (vm.formData.recordType == "CNAME" && value.length > vm.$store.state.maxRecordLb.cname)
                        return callback(new Error("Limit Exceeded"));
                    callback();
                },
                trigger: "blur",
            },
        ],
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            var slbs = vm.getEsResult ? params.row.slbs.map((e) => vm.getEsResult.slbs.find((s) => e == s.nodeId)) : [];
            return h(
                "div",
                slbs
                    .slice()
                    .sort()
                    .map(function (s) {
                        let serviceProvideTypeTag = s.serviceProvideType == "normal" ? "N" : "P";
                        return h(
                            "Tag",
                            {
                                props: {
                                    color: s.runningStat,
                                },
                            },
                            `${s.hostname}(${serviceProvideTypeTag}):${s.serviceIP} ${s.line}`
                        );
                    })
            );
        },
        remoteOptions: async (queryParams) => {
            queryParams.serviceProvideType = "normal";
            let queryString = new URLSearchParams(queryParams).toString();
            let result = await getFormOptions(`/slbnames?${queryString}`);
            return result.data.options;
        },
        queryParamsFields: [{ fieldName: "groupName", queryIf: (val) => val !== "" }, "recordType"],
    };
};

export const isEnforceProtectWithSwitch = (parentVue) => {
    return {
        formTypes: ["createForm", "editForm", "multiEditForm"],
        align: "center",
        render: (h, params) => {
            var status = params.row.isEnforceProtect;
            var vm = parentVue.$refs.rcmTable;
            var content = params.row.isEnforceProtect
                ? vm.$i18n.t("servicegroup.disableEnforceProtectContent")
                : vm.$i18n.t("servicegroup.enableEnforceProtectContent");

            return h("i-switch", {
                props: {
                    value: status,
                    beforeChange() {
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("servicegroup.changeProtectModeStatusText"),
                                content,
                                width: 40,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    },
                },
                on: {
                    "on-change": (value) => {
                        params.row.isEnforceProtect = !params.row.isEnforceProtect;
                        delete params.row._index;
                        delete params.row._rowKey;
                        delete params.row._checked;
                        _updateData("rcm-servicegroup", "index", params.row)
                            .then((result) => {
                                vm.$Notice.success({
                                    title: vm.$i18n.t("global.success"),
                                    desc: `${result.data.message}`,
                                });
                            })
                            .catch(function (error) {
                                vm.$Notice.warning({
                                    title: vm.$i18n.t("global.error"),
                                    desc: `${error}`,
                                });
                                vm.getTableData();
                            });
                    },
                },
            });
        },
    };
};
export const isEnforceProtectWithPaw = (parentVue) => {
    return {
        formTypes: ["createForm", "editForm", "multiEditForm"],
        align: "center",
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            var type = params.row.isEnforceProtect == true ? "ios-paw" : "ios-paw-outline";
            var size = "24";
            var content = params.row.isEnforceProtect
                ? vm.$i18n.t("servicegroup.disableEnforceProtectContent")
                : vm.$i18n.t("servicegroup.enableEnforceProtectContent");
            return h("icon", {
                props: {
                    type,
                    size,
                },
                on: {
                    click: (value) => {
                        vm.$Modal.confirm({
                            title: vm.$i18n.t("servicegroup.changeProtectModeStatusText"),
                            content,
                            okText: vm.$i18n.t("rcmtable.confirmText"),
                            cancelText: vm.$i18n.t("rcmtable.cancelText"),
                            onOk: () => {
                                params.row.isEnforceProtect = !params.row.isEnforceProtect;
                                delete params.row._index;
                                delete params.row._rowKey;
                                delete params.row._checked;
                                _updateData("rcm-servicegroup", "index", params.row)
                                    .then((result) => {
                                        vm.$Notice.success({
                                            title: vm.$i18n.t("global.success"),
                                            desc: `${result.data.message}`,
                                        });
                                    })
                                    .catch(function (error) {
                                        vm.$Notice.warning({
                                            title: vm.$i18n.t("global.error"),
                                            desc: `${error}`,
                                        });
                                        vm.getTableData();
                                    });
                            },
                        });
                    },
                },
            });
        },
    };
};
export const description = (parentVue) => {
    return {
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            return h(
                "Input",
                {
                    props: {
                        value: params.row.description,
                        disabled: isAdmin ? false : !vm.$can("write", "groupResourcesPermission", "ServiceGroup"),
                    },
                    on: {
                        "on-blur": (event) => {
                            if (params.row.description !== event.target.value) {
                                params.row.description = event.target.value;
                                _updateData("rcm-servicegroup", "partialUpdate", {
                                    // docId: `${params.row.groupName}-${params.row.serviceGroupName}`,
                                    docId: params.row._id,
                                    groupName: params.row.groupName,
                                    updateData: {
                                        description: params.row.description,
                                    },
                                    esIndex: "rcm-servicegroup",
                                })
                                    .then((result) => {
                                        vm.$Notice.success({
                                            title: vm.$i18n.t("global.success"),
                                            desc: `${result.data.message}`,
                                        });
                                    })
                                    .catch(function (error) {
                                        vm.$Notice.warning({
                                            title: vm.$i18n.t("global.error"),
                                            desc: `${error}`,
                                        });
                                        vm.getTableData();
                                    });
                            }
                        },
                    },
                },
                ""
            );
        },
    };
};



// WEBPACK FOOTER //
// ./src/view/ServiceGroup/fields.js